export const SET_INSTRUCTOR_DDAHS_FOR_EMAIL = "SET_INSTRUCTOR_DDAHS_FOR_EMAIL";
export const SET_INSTRUCTOR_ACTIVE_POSITION = "SET_INSTRUCTOR_ACTIVE_POSITION";
